import React from 'react';
import MaterialTable from 'material-table';
import tableIcons from './tableIcons';

const DataTable = (props) => <MaterialTable icons={tableIcons} {...props} />;

export default DataTable;
